/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CalendarEntity } from '../models/CalendarEntity';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CalendarCustomerService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Create a Calendar
     * @returns CalendarEntity Create a Calendar
     * @throws ApiError
     */
    public calendarCustomerControllerCreateCalendarV1(): CancelablePromise<CalendarEntity> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/customer/calendar',
        });
    }
    /**
     * Get all Calendars
     * @returns CalendarEntity all calendars have been returned
     * @throws ApiError
     */
    public calendarCustomerControllerGetCalendarsV1(): CancelablePromise<Array<CalendarEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/customer/calendar',
        });
    }
    /**
     * Get a Calendar
     * @param calendarId
     * @returns CalendarEntity The calendar has been returned
     * @throws ApiError
     */
    public calendarCustomerControllerGetCalendarV1(
        calendarId: string,
    ): CancelablePromise<CalendarEntity> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/customer/calendar/{calendarId}',
            path: {
                'calendarId': calendarId,
            },
        });
    }
    /**
     * Archive a Calendar
     * @param calendarId
     * @returns CalendarEntity The archived calendar has been returned
     * @throws ApiError
     */
    public calendarCustomerControllerArchiveCalendarV1(
        calendarId: string,
    ): CancelablePromise<CalendarEntity> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/customer/calendar/{calendarId}/archive',
            path: {
                'calendarId': calendarId,
            },
        });
    }
}
